import React, { useRef, useState } from "react";
import { ScrollView, StyleSheet, TextInput, View } from "react-native";

import { Img, Header, Icon, Input, Text, Toast, Button } from "components";

import { colors, sizes, strings } from "assets/constants";
import { useConfirmWholesaler, useWholesalerCode } from "clients/apis";
import css from "styles";
import { _goToBack } from "routers/helper";

export default function Wholesaler() {
  const codeInput = useRef<TextInput>();
  const [wholesaler, setWholesaler] = useState<WholesalerT | null>(null);
  const [isExist, setIsExist] = useState(true);
  const [code, setCode] = useState("");

  const { refetch, isFetching } = useWholesalerCode(code);
  const confirmWholesalerMut = useConfirmWholesaler();

  const _onCheck = () => {
    if (!code) {
      Toast.warning({ message: "کد بنکدار را وارد کنید" });
      return;
    }

    codeInput.current?.blur();
    refetch().then((res: any) => {
      if (res.status === "success") {
        setWholesaler(res?.data?.data?.wholesaler);
        setIsExist(res?.data?.data?.is_exist);
        res?.data?.data?.is_exist &&
          Toast.success({ message: res?.data?.data?.message });

        return;
      }

      res?.error?.response?.data?.message &&
        Toast.warning({ message: res?.error?.response?.data?.message });
    });
  };

  const _onConfirm = () =>
    confirmWholesalerMut.mutate(
      { code: wholesaler?.code },
      {
        onSuccess: (res) => {
          Toast.success({ message: res?.data?.message });
          _goToBack();
        },
      }
    );

  return (
    <>
      <Header title={strings.add_wholesaler} />
      <View style={{ ...css.container, backgroundColor: colors.screensBg }}>
        <View style={styles.header}>
          <View style={styles.inputContainer}>
            <Input
              inputRef={codeInput}
              hideError
              icon={{ name: "edit-2" }}
              placeholder="کد بنکداری را وارد کنید"
              onChangeText={setCode}
              value={code}
              onSubmitEditing={_onCheck}
            />
          </View>
          <Button
            onPress={_onCheck}
            width={110}
            loading={isFetching}
            title={{ value: "بررسی کد" }}
          />
        </View>

        <ScrollView
          contentContainerStyle={{
            ...css.paddingH,
            ...css.growContainer,
            paddingVertical: sizes.space,
          }}
        >
          {wholesaler ? (
            <>
              <View style={styles.wholesaler}>
                <View style={styles.avatarContainer}>
                  <View style={styles.avatarPlaceholder}>
                    <Icon name="user" size={40} color={colors.lightButtons} />
                  </View>
                  <Img
                    style={styles.avatar}
                    source={{ uri: wholesaler.avatar }}
                  />
                </View>

                <View style={{ marginBottom: 3 }}>
                  <Text weight="bold" size={"lg"} style={{ marginBottom: 5 }}>
                    {wholesaler?.name}
                  </Text>
                  <Text size={"sm"} weight="black">
                    {wholesaler?.mobile}
                  </Text>
                </View>
              </View>

              <View style={styles.address}>
                <Icon style={{ top: 1 }} name="map-pin" size={17} />
                <Text weight="bold"> {wholesaler?.province?.text}</Text>
                <Text weight="bold"> - {wholesaler?.city?.text}</Text>
                {wholesaler?.Address && <Text> - {wholesaler?.Address}</Text>}
              </View>
              {wholesaler?.store_name && (
                <View style={styles.store}>
                  <Icon name="shopping-bag" style={{ top: 1 }} size={17} />
                  <Text> {wholesaler?.store_name}</Text>
                </View>
              )}
            </>
          ) : (
            <View style={{ ...css.centralElements, marginTop: 25 }}>
              <Icon size={28} name="search" />
              <Text
                align="center"
                style={{
                  lineHeight: 25,
                  paddingHorizontal: 15,
                  marginTop: 15,
                }}
              >
                برای افزودن بنکدار جدید، کد بنکداری را در فیلد فوق وارد کرده و
                روی «بررسی کد» کلیک کنید تا اطلاعات بنکدار نمایش داده شود.
              </Text>
            </View>
          )}
          <View style={css.container} />
          {!isExist && (
            <Button
              title={{ value: "تایید بنکدار" }}
              loading={confirmWholesalerMut?.isLoading}
              onPress={_onConfirm}
            />
          )}
        </ScrollView>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: "row-reverse",
    padding: 12,
    alignItems: "center",
  },

  avatarContainer: {
    width: 80,
    height: 80,
    elevation: 2,
    borderWidth: 2,
    borderRadius: 60,
    alignSelf: "flex-end",
    borderColor: colors.itemsBg,
    backgroundColor: colors.itemsBg,
    marginLeft: 10,
  },

  avatar: { width: "100%", height: "100%", borderRadius: 60 },

  inputContainer: { flex: 1, marginLeft: 12 },

  address: { flexDirection: "row-reverse", marginTop: 10 },

  store: { flexDirection: "row-reverse", marginVertical: 10 },

  wholesaler: {
    flexDirection: "row-reverse",
    alignItems: "flex-end",
    marginBottom: 10,
  },

  avatarPlaceholder: {
    position: "absolute",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
});
